import { SPORTS } from 'shared/constants/common';

// array contians sport ids for which we need to display time
const NEED_TO_DISPLAY_TIME = [
	SPORTS.FOOTBALL,
	SPORTS.BASKETBALL,
	SPORTS.ICE_HOCKEY,
	SPORTS.AM_FOOTBAL,
	SPORTS.HANDBALL,
	SPORTS.FUTSAL,
	SPORTS.BASKETBALL_3X3,
	SPORTS.BEACH_SOCCER,
	SPORTS.RUGBY,
	SPORTS.CRICKET,
	SPORTS.AUSSIE_RULES,
	SPORTS.FIELD_HOCKEY,
	SPORTS.MMA,
	SPORTS.BOXING,
	SPORTS.ESPORT_FIFA,
];

/**
 * To get event time which needs to be display on event card
 * @export
 * @param {number} sportId event sport id
 * @param {number} time event time
 * @returns event time string
 */
export const getLiveEventTimeString = (sportId: number, time: number) => {
	if (!NEED_TO_DISPLAY_TIME.includes(sportId)) {
		return '';
	}
	if (time === 0) {
		return '';
	}

	return `${Math.floor(time / 60)} min.`;
};
